"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _everdaysLogo = _interopRequireDefault(require("../../../../images/shared/icons/everdays-logo.svg"));

require("./ModalLogoHeader.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalLogoHeader = function ModalLogoHeader(_ref) {
  var customClass = _ref.customClass;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-logo-header ".concat(customClass)
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _everdaysLogo.default,
    alt: "Everdays logo"
  }));
};

var _default = ModalLogoHeader;
exports.default = _default;